import type { CandidateResume as CandidateResumeData } from '@entities/candidates';
import { useState } from 'react';
import { CandidateResumeCard } from './components/CandidateResume.card';
import { CandidateResumeForm } from './components/CandidateResume.form';
import { formatCandidateResume } from './utils/formatCandidateResume';
import { getCandidateResumeEditInitialValues } from './utils/getCandidateResumeEditInitialValues';

export type CandidateResumeProps = {
  data: CandidateResumeData;
};

export const CandidateResume = ({ data }: CandidateResumeProps) => {
  const [isEditing, setIsEditing] = useState(false);

  if (isEditing) {
    return (
      <CandidateResumeForm
        candidateId={data.candidateId}
        resumeId={data.resumeId}
        initialValues={getCandidateResumeEditInitialValues(data)}
        onCancel={() => setIsEditing(false)}
        onSuccess={() => setIsEditing(false)}
      />
    );
  }

  return (
    <CandidateResumeCard
      {...formatCandidateResume(data)}
      onEdit={() => setIsEditing(true)}
    />
  );
};
